export default function getO365ShellShim() {
    return window.O365Shell;
}
//# sourceMappingURL=getO365ShellShim.js.map